<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="md"
    :modal-title="`개별 학생코드 생성`"
    :confirm="save"
    :close="close"
    confirmButtonTitle="저장"
    :loading="loading"
    name="createAccountModal"
  >
    <b-container>
      <b-row class="my-2">
        <b-col>
          <b-form-floating-label>
            이름
          </b-form-floating-label>
          <b-form-input
            id="input-1"
            v-model="name"
            type="text"
            required
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-floating-label>전화번호</b-form-floating-label>
          <b-form-input
            id="input-1"
            v-model.trim="phoneNumber"
            type="text"
            required
            @keyup="formatPhoneNumber(phoneNumber)"
          />
        </b-col>
      </b-row>
    </b-container>
  </AdminModal>
</template>

<script>
import api from "@/api/api"
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  name: "CreateAccountModal",
  components: {AdminModal},
  props: ['isOpen', 'reload', 'close', 'lessonAccountOption'],
  data() {
    return {
      name : "",
      phoneNumber: "",
      loading: false
    }
  },
  methods: {
    formatPhoneNumber(phoneNumber) {
      if (phoneNumber.length === 0 || phoneNumber.length <= 3) {
        this.phoneNumber = phoneNumber
      } else {
        let input = phoneNumber;
        // 숫자만 남기고 모두 제거
        input = input.replace(/[^0-9]/g, "");

        let result = [];
        let restNumber = input;

        if (restNumber.length > 3) {
          result.push(restNumber.substr(0, 3));
          restNumber = restNumber.substring(3);
        }

        if (restNumber.length > 4) {
          result.push(restNumber.substr(0, 4));
          restNumber = restNumber.substring(4);
        }

        if (restNumber.length > 0) {
          result.push(restNumber);
        }

        this.phoneNumber = result.join("-");
      }
    },
    save() {
      if (this.name.length === 0) {
        this.$toast.error('이름을 입력해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }

      const regPhone = /^([0-9]{3})-?([0-9]{3,4})-?([0-9]{4})$/;
      if (!regPhone.test(this.phoneNumber) || this.phoneNumber.length === 0 || this.phoneNumber.length > 13) {
        this.$toast.error('올바른 전화번호를 입력해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }

      this.loading = true
      const params = {
        name: this.name,
        phoneNumber: this.phoneNumber,
        accountType: this.lessonAccountOption
      }
      api.lessonAccesses.createLessonAccess(params, () => {
        this.reload();
        this.close();
      }, (error) => {
        console.log(error)
        this.loading=false
        const errorData = error.response.data
        this.$toast.show(errorData.message,
          {
            type: "error",
            position: "top-right",
            duration: 2000,
            max: 10
          });
        return
      })
      
    }
  }
}
</script>

<style scoped>

</style>